import classNames from 'classnames';

import allCoins from '../../../assets/all-coins.png';
import allDollars from '../../../assets/all-dollars.png';
import bigCoins from '../../../assets/big-coins.png';
import coins from '../../../assets/coins.png';
import coinsPile from '../../../assets/coinsPile.png';
import dollars from '../../../assets/dollars.png';
import extraCoins from '../../../assets/extra-coins.png';
import mediumCoins from '../../../assets/medium-coins.png';

import classes from './BonusCards.module.scss';

const images = new Map([
  [1, coinsPile],
  [2, coins],
  [3, dollars],
  [4, mediumCoins],
  [5, bigCoins],
  [6, extraCoins],
  [7, allCoins],
  [-1, allDollars], // second image for last day
]);

export default function WinImage(props: { day: number; imageUrl?: string; small?: boolean }) {
  let source = images.get(props.day);
  if (typeof props.imageUrl === 'string') {
    source = props.imageUrl;
  }

  return (
    <img
      alt="bonus"
      className={classNames(classes.image, props.small ? classes.small : '')}
      src={source}
      width="100%"
    />
  );
}
